<template>
    <div class="ion-page">
      <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <!-- <ion-menu-button></ion-menu-button> -->
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Charger Status List</ion-title>
            </ion-buttons>
          </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ChargerStatusList />
      </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerStatusList from "@/components/admin/ChargerStatusList.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
  name:  'chargerStatusList',
  components: {
    ChargerStatusList, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent
  },
  data() {
    return {

    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    }
  }
})
</script>
